export const authRouteName = {
  login: "auth.login",
  addAccount: "auth.add-account",
  mfaMethod: "auth.mfa-method",
  otpVerify: "auth.otp-verify",
  callback: "auth.callback",
};

export const authRoute = [
  {
    path: "/auth/login",
    name: authRouteName.login,
    component: () => import("../pages/LoginPage.vue"),
    meta: {
      requireAuth: false,
      layout: "SSOAuth",
      breadcrumbs: () => {
        return [{}];
      },
    },
  },
  {
    path: "/auth/login/add-account",
    name: authRouteName.addAccount,
    component: () => import("../pages/AddAccountPage.vue"),
    meta: {
      requireAuth: false,
      layout: "SSOAuth",
      breadcrumbs: () => {
        return [{}];
      },
    },
  },
  {
    path: "/auth/login/mfa-method",
    name: authRouteName.mfaMethod,
    component: () => import("../pages/MFAMethodPage.vue"),
    meta: {
      requireAuth: false,
      layout: "SSOAuth",
      breadcrumbs: () => {
        return [{}];
      },
    },
  },
  {
    path: "/auth/login/otp-verify",
    name: authRouteName.otpVerify,
    component: () => import("../pages/OTPVerifyPage.vue"),
    meta: {
      requireAuth: false,
      layout: "SSOAuth",
      breadcrumbs: () => {
        return [{}];
      },
    },
  },
  {
    path: "/auth/callback",
    name: authRouteName.callback,
    component: () => import("../pages/AuthCallbackPage.vue"),
    meta: {
      requireAuth: false,
      layout: "SSOAuth",
      breadcrumbs: () => {
        return [{}];
      },
    },
  },
];
